import React from 'react';
import { t } from '@lingui/macro';

import { Button } from '@rover/kibble/core';
import type { EnhancedPersonSitterProfileService } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfileService';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import { PriceTransparencyLevel } from '@rover/types/src/PriceTransparencyLevel';

import AdditionalRatesSection from '../ServiceSection/AdditionalRatesSection';

import { SitterProfileSeeAllRatesClicked } from './analyticsEvents';

const RevampAdditionalRates = ({
  services,
  serviceType,
  isSitterInPetCareModesExperiment,
  priceTransparencyLevel,
}: {
  services: EnhancedPersonSitterProfileService[];
  serviceType: string | undefined;
  isSitterInPetCareModesExperiment: boolean;
  priceTransparencyLevel: PriceTransparencyLevel;
}): JSX.Element => (
  <AdditionalRatesSection
    services={services}
    isSitterInPetCareModesExperiment={isSitterInPetCareModesExperiment}
    priceTransparencyLevel={priceTransparencyLevel}
    renderTrigger={(toggleModal) => (
      <Button
        variant="link"
        onPress={() => {
          emitAnalyticsEvent(
            new SitterProfileSeeAllRatesClicked({
              serviceSlug: serviceType ?? '',
              pageVariant: 'revamp',
            })
          );
          toggleModal();
        }}
        data-testid="revamp-see-all-rates"
        alignSelf="flex-start"
      >
        {t`See all rates`}
      </Button>
    )}
    isCtaModal
    isRevampVersion
  />
);

export default RevampAdditionalRates;
